// Complete Services & Pricing Catalog - Modular Structure
export const SERVICE_CATEGORIES = {
  research_writing: {
    id: 'research_writing',
    title: 'Research & Writing',
    icon: 'bi-book',
    description: 'Strategic research, analysis, and content creation services',
    color: '#4CAF50',
    services: {
      strategic_research: {
        id: 'strategic_research',
        title: 'Strategic Research Report',
        thumbnails: ['Data + Strategy dashboard collage', 'Designer at research wall with insights', 'Clean executive report spread mockup'],
        pricing: '$165/hr | $4,000–$8,000',
        tldr: 'Deep, cited research to inform product, business, or design strategy. Includes synthesis, insight modeling, and visual summaries for decision-makers.',
        description: 'Deep, cited research to inform product, business, or design strategy. Includes synthesis, insight modeling, and visual summaries for decision-makers.',
        hourlyRate: 165,
        priceRange: [4000, 8000],
        timeframe: '10–14 days',
        deliverables: ['1 report concept', '2 revision rounds'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Google Scholar', 'Notion', 'Figma', 'Adobe CC']
      },
      market_competitive: {
        id: 'market_competitive',
        title: 'Market, Trend & Competitive Landscape Analysis',
        thumbnails: ['Competitive matrix visualization', 'Market segmentation grid', 'SWOT + Five Forces hybrid diagram'],
        pricing: '$185/hr | $4,500–$9,000',
        tldr: 'Full environmental and competitor mapping using visual frameworks and strategic analysis.',
        description: 'Full environmental and competitor mapping using visual frameworks and strategic analysis.',
        hourlyRate: 185,
        priceRange: [4500, 9000],
        timeframe: '2–3 weeks',
        deliverables: ['1 master framework', '2 revision rounds'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Tableau', 'Figma', 'Adobe CC', 'Excel']
      },
      concept_development: {
        id: 'concept_development',
        title: 'Concept & Product Development Report',
        thumbnails: ['Product concept card layout', 'Risk vs feasibility matrix', 'UX + tech feasibility diagram'],
        pricing: '$200/hr | $6,000–$10,000',
        tldr: 'Research-driven concept creation with technical, UX, and business feasibility scoring.',
        description: 'Research-driven concept creation with technical, UX, and business feasibility scoring.',
        hourlyRate: 200,
        priceRange: [6000, 10000],
        timeframe: '2–3 weeks',
        deliverables: ['2–3 concepts', '2 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Figma', 'Notion', 'Adobe CC', 'Miro']
      },
      case_study: {
        id: 'case_study',
        title: 'Case Study Authoring',
        thumbnails: ['Before/after product boards', 'KPIs + outcomes spread', 'Process timeline layout'],
        pricing: '$165/hr | $3,000–$6,000',
        tldr: 'Professional project documentation with interviews, narrative arc, and performance metrics.',
        description: 'Professional project documentation with interviews, narrative arc, and performance metrics.',
        hourlyRate: 165,
        priceRange: [3000, 6000],
        timeframe: '1–2 weeks',
        deliverables: ['1 narrative', '2 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Figma', 'Notion', 'Adobe CC']
      },
      customer_interviews: {
        id: 'customer_interviews',
        title: 'Customer Interview & Qualitative Study',
        thumbnails: ['Remote interview screen grid', 'Insight cluster visualization', 'Persona emergence board'],
        pricing: '$200/hr | $6,500–$12,000',
        tldr: 'Recruitment, interviewing, thematic coding, and insight synthesis.',
        description: 'Recruitment, interviewing, thematic coding, and insight synthesis.',
        hourlyRate: 200,
        priceRange: [6500, 12000],
        timeframe: '3–4 weeks',
        deliverables: ['1 study framework', '2 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Zoom', 'Miro', 'Notion']
      },
      survey_study: {
        id: 'survey_study',
        title: 'Survey Study (Quantitative)',
        thumbnails: ['Survey interface mockup', 'Data results dashboard', 'Statistical summary charts'],
        pricing: '$185/hr | $5,000–$9,500',
        tldr: 'Survey design, deployment, and statistical analysis via Google Forms or Typeform.',
        description: 'Survey design, deployment, and statistical analysis via Google Forms or Typeform.',
        hourlyRate: 185,
        priceRange: [5000, 9500],
        timeframe: '2–3 weeks',
        deliverables: ['1 survey instrument', '2 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Google Forms', 'Typeform', 'Excel', 'Tableau']
      },
      affinity_mapping: {
        id: 'affinity_mapping',
        title: 'Affinity Mapping & Insight Synthesis',
        thumbnails: ['Massive sticky-note clustering', 'Digital Miro/FigJam mapping', 'Insight hierarchy diagram'],
        pricing: '$185/hr | $4,500–$8,500',
        tldr: 'Transforms qualitative chaos into structured insights using visual synthesis.',
        description: 'Transforms qualitative chaos into structured insights using visual synthesis.',
        hourlyRate: 185,
        priceRange: [4500, 8500],
        timeframe: '1–2 weeks',
        deliverables: ['1 master map', '2 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Miro', 'FigJam', 'Notion']
      },
      persona_journey: {
        id: 'persona_journey',
        title: 'Persona & Journey Mapping Pack',
        thumbnails: ['Persona profile cards', 'User journey swimlane', 'Emotional + task overlays'],
        pricing: '$185/hr | $3,500–$7,000',
        tldr: '2–4 personas + end-to-end journey maps with behavioral and emotional analysis.',
        description: '2–4 personas + end-to-end journey maps with behavioral and emotional analysis.',
        hourlyRate: 185,
        priceRange: [3500, 7000],
        timeframe: '1–2 weeks',
        deliverables: ['Up to 4 personas', '2 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Figma', 'Miro', 'Adobe CC']
      },
      messaging_framework: {
        id: 'messaging_framework',
        title: 'Messaging & Narrative Framework',
        thumbnails: ['Brand voice pyramid', 'Messaging architecture chart', 'Campaign copy hierarchy'],
        pricing: '$200/hr | $4,000–$8,000',
        tldr: 'Strategic communication systems defining tone, hierarchy, and messaging clarity.',
        description: 'Strategic communication systems defining tone, hierarchy, and messaging clarity.',
        hourlyRate: 200,
        priceRange: [4000, 8000],
        timeframe: '2 weeks',
        deliverables: ['1 framework', '2 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Notion', 'Figma', 'Google Docs']
      },
      custom_rd: {
        id: 'custom_rd',
        title: 'Custom R&D Package',
        thumbnails: ['Multi-discipline system board', 'Research + UX + Strategy hybrid deck', 'Innovation pipeline diagram'],
        pricing: '$225/hr | $8,500–$15,000+',
        tldr: 'Hybrid engagement blending research, UX, strategy, and messaging for large initiatives.',
        description: 'Hybrid engagement blending research, UX, strategy, and messaging for large initiatives.',
        hourlyRate: 225,
        priceRange: [8500, 15000],
        timeframe: '3–4+ weeks',
        deliverables: ['Multi-phase concepts', '3 revisions'],
        profileInfo: {
          logo: 'JM Logo',
          name: 'JM Crawford',
          age: 39,
          location: 'United States',
          responseTime: 'Responds Quickly ✅'
        },
        tools: ['Full toolkit', 'Custom tech stack']
      }
    }
  },
  design_visual: {
    id: 'design_visual',
    title: 'Design & Visual Strategy',
    icon: 'bi-palette',
    description: 'Brand identity, visual systems, and strategic design',
    color: '#FF9800',
    services: {
      brand_identity: {
        id: 'brand_identity',
        title: 'Brand Identity System Design',
        thumbnails: ['Full logo system spread', 'Color + typography token board', 'Brand applied across web + print'],
        pricing: '$200/hr | $6,000–$12,000',
        tldr: 'Complete logo, typography, color, and usage system aligned with core strategy.',
        description: 'Complete logo, typography, color, and usage system aligned with core strategy.',
        hourlyRate: 200,
        priceRange: [6000, 12000],
        timeframe: '10–14 days',
        deliverables: ['2–3 identity directions', '2 revisions'],
        tools: ['Adobe CC Suite', 'Figma', 'Illustrator']
      },
      brand_strategy: {
        id: 'brand_strategy',
        title: 'Brand Strategy & Activation',
        thumbnails: ['Positioning matrix', 'Brand purpose/voice framework', 'Go-to-market activation visuals'],
        pricing: '$185/hr | $4,000–$9,000',
        tldr: 'Defines purpose, voice, audience segments, and brand experience touchpoints.',
        description: 'Defines purpose, voice, audience segments, and brand experience touchpoints.',
        hourlyRate: 185,
        priceRange: [4000, 9000],
        timeframe: '2–3 weeks',
        deliverables: ['1 master strategy', '2 revisions'],
        tools: ['Figma', 'Miro', 'Adobe CC']
      },
      campaign_design: {
        id: 'campaign_design',
        title: 'Visual Communication & Campaign Design',
        thumbnails: ['Campaign key visual', 'Social + display ad grid', 'Multi-platform rollout sheet'],
        pricing: '$175/hr | $3,500–$9,000',
        tldr: 'Integrated creative direction for product launches, events, and marketing campaigns.',
        description: 'Integrated creative direction for product launches, events, and marketing campaigns.',
        hourlyRate: 175,
        priceRange: [3500, 9000],
        timeframe: '2–4 weeks',
        deliverables: ['2–3 campaign concepts', '2 revisions'],
        tools: ['Adobe CC Suite', 'Figma', 'After Effects']
      },
      print_packaging: {
        id: 'print_packaging',
        title: 'Print & Packaging Design',
        thumbnails: ['Packaging dielines', 'Editorial spreads', 'Physical mockups'],
        pricing: '$150/hr | $2,500–$7,500',
        tldr: 'Editorial, brochure, book, and packaging design with print-ready files.',
        description: 'Editorial, brochure, book, and packaging design with print-ready files.',
        hourlyRate: 150,
        priceRange: [2500, 7500],
        timeframe: '1–3 weeks',
        deliverables: ['2 concepts', '2 revisions'],
        tools: ['InDesign', 'Illustrator', 'Photoshop']
      },
      typography_layout: {
        id: 'typography_layout',
        title: 'Typography & Layout Systems',
        thumbnails: ['Custom typographic grid', 'Expressive poster layouts', 'Publication hierarchy system'],
        pricing: '$150/hr | $2,000–$6,000',
        tldr: 'Custom typographic hierarchy systems for brands, posters, and publications.',
        description: 'Custom typographic hierarchy systems for brands, posters, and publications.',
        hourlyRate: 150,
        priceRange: [2000, 6000],
        timeframe: '1–2 weeks',
        deliverables: ['2 typographic systems', '2 revisions'],
        tools: ['InDesign', 'Illustrator', 'Figma']
      },
      environmental_design: {
        id: 'environmental_design',
        title: 'Environmental & Spatial Design',
        thumbnails: ['Event signage system', 'Wayfinding design boards', 'Large-format brand environments'],
        pricing: '$200/hr | $5,000–$10,000',
        tldr: 'Event branding, exhibit systems, spatial graphics, and signage design.',
        description: 'Event branding, exhibit systems, spatial graphics, and signage design.',
        hourlyRate: 200,
        priceRange: [5000, 10000],
        timeframe: '2–4 weeks',
        deliverables: ['2 environment concepts', '2 revisions'],
        tools: ['Adobe CC Suite', 'Figma', 'Cinema 4D']
      },
      illustration_iconography: {
        id: 'illustration_iconography',
        title: 'Illustration & Iconography Systems',
        thumbnails: ['UI icon systems', 'Brand motif illustrations', 'SVG component libraries'],
        pricing: '$125/hr | $1,500–$4,000',
        tldr: 'Custom vector icons, illustrations, and scalable brand motif systems.',
        description: 'Custom vector icons, illustrations, and scalable brand motif systems.',
        hourlyRate: 125,
        priceRange: [1500, 4000],
        timeframe: '1–2 weeks',
        deliverables: ['1 system + icon samples', '2 revisions'],
        tools: ['Illustrator', 'Figma', 'Photoshop']
      },
      motion_animation: {
        id: 'motion_animation',
        title: 'Motion, Animation & AR/VR Design',
        thumbnails: ['Motion branding frames', 'Product animation sequences', 'Immersive AR overlays'],
        pricing: '$185/hr | $4,000–$9,000',
        tldr: 'Motion graphics, product animation, and immersive experience prototyping.',
        description: 'Motion graphics, product animation, and immersive experience prototyping.',
        hourlyRate: 185,
        priceRange: [4000, 9000],
        timeframe: '2–4 weeks',
        deliverables: ['2 animation concepts', '2 revisions'],
        tools: ['After Effects', 'Cinema 4D', 'Blender', 'Unity']
      },
      logo_mark: {
        id: 'logo_mark',
        title: 'Logo & Mark Design',
        thumbnails: ['Primary logo directions', 'Responsive logo grid', 'Motion lockup preview'],
        pricing: '$165/hr | $3,500 flat',
        tldr: 'Distinctive logo systems for digital, print, and motion environments.',
        description: 'Distinctive logo systems for digital, print, and motion environments.',
        hourlyRate: 165,
        priceRange: [3500, 3500],
        timeframe: '5–7 days',
        deliverables: ['3 logo concepts', '2 revisions'],
        tools: ['Illustrator', 'Figma', 'After Effects']
      },
      icon_systems: {
        id: 'icon_systems',
        title: 'Iconography & Symbol Systems',
        thumbnails: ['Stroke-grid icon systems', 'UI component icons', 'App symbol libraries'],
        pricing: '$165/hr | $1,200 base + $150/icon',
        tldr: 'Scalable icon systems for apps, signage, and interface components.',
        description: 'Scalable icon systems for apps, signage, and interface components.',
        hourlyRate: 165,
        priceRange: [1200, 5000],
        timeframe: '5–14 days',
        deliverables: ['1 system', '2 revisions'],
        tools: ['Illustrator', 'Figma', 'Sketch']
      },
      brand_illustration: {
        id: 'brand_illustration',
        title: 'Illustration & Brand Artwork',
        thumbnails: ['Editorial illustrations', 'Mascot development', 'Hero brand artwork'],
        pricing: '$165–$200/hr | $2,500–$8,000',
        tldr: 'Original vector and raster illustrations aligned to brand aesthetic.',
        description: 'Original vector and raster illustrations aligned to brand aesthetic.',
        hourlyRate: 200,
        priceRange: [2500, 8000],
        timeframe: '1–3 weeks',
        deliverables: ['2–3 concepts', '2 revisions'],
        tools: ['Illustrator', 'Photoshop', 'Procreate']
      },
      photo_retouching: {
        id: 'photo_retouching',
        title: 'Photo Retouching, Color Grading & Asset Prep',
        thumbnails: ['Before/after retouching', 'Batch export grids', 'Color grading LUT previews'],
        pricing: '$150/hr | $600–$2,500',
        tldr: 'Professional image cleanup, grading, batching, and export optimization.',
        description: 'Professional image cleanup, grading, batching, and export optimization.',
        hourlyRate: 150,
        priceRange: [600, 2500],
        timeframe: '3–10 days',
        deliverables: ['Rolling edits', '2 revision rounds'],
        tools: ['Photoshop', 'Lightroom', 'Capture One']
      },
      marketing_creative: {
        id: 'marketing_creative',
        title: 'Marketing & Campaign Creative',
        thumbnails: ['Launch campaign visuals', 'Motion + print rollout', 'Web hero + banners'],
        pricing: '$185–$225/hr | $6,000–$12,000',
        tldr: 'End-to-end creative development for high-impact marketing campaigns.',
        description: 'End-to-end creative development for high-impact marketing campaigns.',
        hourlyRate: 225,
        priceRange: [6000, 12000],
        timeframe: '3–5 weeks',
        deliverables: ['3 campaign concepts', '2 revisions'],
        tools: ['Adobe CC Suite', 'Figma', 'After Effects']
      },
      template_systems: {
        id: 'template_systems',
        title: 'Mockups, Template Libraries & Systems',
        thumbnails: ['Figma component layouts', 'Web + mobile templates', 'Reusable brand smart objects'],
        pricing: '$165/hr | $1,200–$3,500',
        tldr: 'Reusable Figma, Adobe, and Webflow templates for production teams.',
        description: 'Reusable Figma, Adobe, and Webflow templates for production teams.',
        hourlyRate: 165,
        priceRange: [1200, 3500],
        timeframe: '5–14 days',
        deliverables: ['1 template system', '2 revisions'],
        tools: ['Figma', 'Adobe CC', 'Webflow']
      }
    }
  },
  ux_product: {
    id: 'ux_product',
    title: 'UX & Product Design',
    icon: 'bi-layers',
    description: 'User experience design, interface design, and product strategy',
    color: '#2196F3',
    services: {
      ux_discovery: {
        id: 'ux_discovery',
        title: 'UX Discovery & Information Architecture',
        thumbnails: ['Sitemap + flow map', 'App IA tree structure', 'Task-flow swimlanes'],
        pricing: '$185/hr | $3,500–$6,000',
        tldr: 'Defines structure, navigation, content hierarchy, and flows before design begins.',
        description: 'Defines structure, navigation, content hierarchy, and flows before design begins.',
        hourlyRate: 185,
        priceRange: [3500, 6000],
        timeframe: '1–2 weeks',
        deliverables: ['1 IA system', '2 revisions'],
        tools: ['Figma', 'Miro', 'Whimsical']
      },
      ux_wireframing: {
        id: 'ux_wireframing',
        title: 'UX Wireframing & Prototyping',
        thumbnails: ['Low-fi screens', 'Clickable prototype map', 'Flow testing boards'],
        pricing: '$185/hr | $5,500–$7,500',
        tldr: 'Low-to-mid fidelity layouts focused on usability, flow, and accessibility.',
        description: 'Low-to-mid fidelity layouts focused on usability, flow, and accessibility.',
        hourlyRate: 185,
        priceRange: [5500, 7500],
        timeframe: '1–2 weeks',
        deliverables: ['5–7 screens', '2 revisions'],
        tools: ['Figma', 'Sketch', 'Adobe XD']
      },
      ui_high_fidelity: {
        id: 'ui_high_fidelity',
        title: 'High-Fidelity UI Design Systems',
        thumbnails: ['Pixel-perfect dashboard UI', 'Mobile + desktop screen sets', 'State system grids'],
        pricing: '$200/hr | $7,500–$13,000',
        tldr: 'Production-ready, componentized UI with full responsive and state logic.',
        description: 'Production-ready, componentized UI with full responsive and state logic.',
        hourlyRate: 200,
        priceRange: [7500, 13000],
        timeframe: '2–3 weeks',
        deliverables: ['5–10 screens', '2 revisions'],
        tools: ['Figma', 'Sketch', 'Adobe XD']
      },
      responsive_layout: {
        id: 'responsive_layout',
        title: 'Responsive Layout & Breakpoint Mapping',
        thumbnails: ['Mobile ⇄ desktop reflow', 'Grid stacking diagrams', 'Device breakpoint charts'],
        pricing: '$200/hr | $2,500–$5,000',
        tldr: 'Documents adaptive behavior across mobile, tablet, and desktop.',
        description: 'Documents adaptive behavior across mobile, tablet, and desktop.',
        hourlyRate: 200,
        priceRange: [2500, 5000],
        timeframe: '1–2 weeks',
        deliverables: ['1 responsive system', '2 revisions'],
        tools: ['Figma', 'Sketch', 'CSS Grid']
      },
      design_system_creation: {
        id: 'design_system_creation',
        title: 'Design System Creation (Figma + Tokens)',
        thumbnails: ['Token architecture boards', 'Component libraries', 'Storybook parity preview'],
        pricing: '$225/hr | $9,000–$25,000',
        tldr: 'Atomic design systems with tokens, variables, JSON, and code parity.',
        description: 'Atomic design systems with tokens, variables, JSON, and code parity.',
        hourlyRate: 225,
        priceRange: [9000, 25000],
        timeframe: '2–4 weeks',
        deliverables: ['Full system', '3 revisions'],
        tools: ['Figma', 'Storybook', 'Tokens Studio']
      },
      motion_microinteractions: {
        id: 'motion_microinteractions',
        title: 'Motion, Micro-Interactions & Animation Spec',
        thumbnails: ['Hover/feedback states', 'Lottie animation previews', 'Motion timelines'],
        pricing: '$200/hr | $2,500–$6,500',
        tldr: 'Defines transitions, animations, and user-feedback behavior.',
        description: 'Defines transitions, animations, and user-feedback behavior.',
        hourlyRate: 200,
        priceRange: [2500, 6500],
        timeframe: '1–2 weeks',
        deliverables: ['2 motion concepts', '2 revisions'],
        tools: ['Figma', 'After Effects', 'Lottie']
      },
      accessibility_audit: {
        id: 'accessibility_audit',
        title: 'Accessibility & Inclusive Design Audit',
        thumbnails: ['Contrast audits', 'Focus order mapping', 'A11y remediation checklist'],
        pricing: '$200/hr | $3,500–$8,000',
        tldr: 'Full WCAG 2.2 AA audit with remediation guidance.',
        description: 'Full WCAG 2.2 AA audit with remediation guidance.',
        hourlyRate: 200,
        priceRange: [3500, 8000],
        timeframe: '1–2 weeks',
        deliverables: ['1 audit', '2 revisions'],
        tools: ['Axe', 'WAVE', 'Figma', 'Lighthouse']
      },
      usability_testing: {
        id: 'usability_testing',
        title: 'Usability Testing & Iteration',
        thumbnails: ['Remote test sessions', 'Affinity insight groups', 'Iteration comparison screens'],
        pricing: '$185/hr | $4,500–$9,000',
        tldr: 'Moderated user testing with insight synthesis and iteration cycles.',
        description: 'Moderated user testing with insight synthesis and iteration cycles.',
        hourlyRate: 185,
        priceRange: [4500, 9000],
        timeframe: '2–3 weeks',
        deliverables: ['5–7 testers', '2 iterations'],
        tools: ['UserTesting', 'Maze', 'Zoom', 'Miro']
      },
      ux_microcopy: {
        id: 'ux_microcopy',
        title: 'UX & Microcopy Writing',
        thumbnails: ['Onboarding copy decks', 'Error state messaging', 'UI tone systems'],
        pricing: '$165/hr | $2,500–$5,500',
        tldr: 'Human-centered interface language for apps and platforms.',
        description: 'Human-centered interface language for apps and platforms.',
        hourlyRate: 165,
        priceRange: [2500, 5500],
        timeframe: '1–2 weeks',
        deliverables: ['Full copy deck', '2 revisions'],
        tools: ['Google Docs', 'Figma', 'Notion']
      },
      dev_handoff: {
        id: 'dev_handoff',
        title: 'Dev Handoff & Design Specification',
        thumbnails: ['Token reference sheets', 'Component export boards', 'Dev annotation maps'],
        pricing: '$200/hr | $2,500–$6,000',
        tldr: 'Clean delivery of specs, tokens, assets, and dev walkthrough.',
        description: 'Clean delivery of specs, tokens, assets, and dev walkthrough.',
        hourlyRate: 200,
        priceRange: [2500, 6000],
        timeframe: '3–7 days',
        deliverables: ['1 handoff system', '2 revisions'],
        tools: ['Figma', 'Zeplin', 'Storybook', 'GitHub']
      },
      implementation_qa: {
        id: 'implementation_qa',
        title: 'Implementation QA & Visual Review',
        thumbnails: ['Design vs build overlay', 'Cross-device QA testing', 'Defect logs'],
        pricing: '$185/hr | $1,800–$4,500',
        tldr: 'Audit of live product against design intent.',
        description: 'Audit of live product against design intent.',
        hourlyRate: 185,
        priceRange: [1800, 4500],
        timeframe: '1–2 weeks',
        deliverables: ['2 audit passes', '2 revisions'],
        tools: ['BrowserStack', 'Figma', 'Chrome DevTools']
      },
      design_system_governance: {
        id: 'design_system_governance',
        title: 'Design System Governance & Maintenance',
        thumbnails: ['Version changelogs', 'Token migration maps', 'Governance workflows'],
        pricing: '$3,500–$7,500 / month (retainer)',
        tldr: 'Ongoing system updates, training, migrations, and version control.',
        description: 'Ongoing system updates, training, migrations, and version control.',
        hourlyRate: 200,
        priceRange: [3500, 7500],
        timeframe: 'Monthly',
        deliverables: ['Continuous updates'],
        tools: ['Figma', 'GitHub', 'Storybook', 'Notion']
      },
      product_design_strategy: {
        id: 'product_design_strategy',
        title: 'Product Design Strategy & Innovation',
        thumbnails: ['Product vision boards', 'Roadmap timelines', 'Feature prioritization grids'],
        pricing: '$225/hr | $6,000–$12,000',
        tldr: 'Connects design thinking to business and engineering goals.',
        description: 'Connects design thinking to business and engineering goals.',
        hourlyRate: 225,
        priceRange: [6000, 12000],
        timeframe: '2–4 weeks',
        deliverables: ['1 product strategy', '2 revisions'],
        tools: ['Figma', 'Miro', 'Notion', 'ProductPlan']
      },
      behavioral_design: {
        id: 'behavioral_design',
        title: 'Human-Centered & Behavioral Design',
        thumbnails: ['Cognitive load mapping', 'Behavior trigger systems', 'Emotional UX overlays'],
        pricing: '$200/hr | $5,000–$10,000',
        tldr: 'Optimizes UX using psychology, behavior, and cognitive patterns.',
        description: 'Optimizes UX using psychology, behavior, and cognitive patterns.',
        hourlyRate: 200,
        priceRange: [5000, 10000],
        timeframe: '2–3 weeks',
        deliverables: ['1 behavioral model', '2 revisions'],
        tools: ['Miro', 'Figma', 'Notion']
      },
      ux_research_insights: {
        id: 'ux_research_insights',
        title: 'UX Research & Data-Driven Insights',
        thumbnails: ['Ethnographic research boards', 'Persona data clustering', 'Insight dashboards'],
        pricing: '$225/hr | $6,000–$12,000',
        tldr: 'Primary and secondary research for product decisions.',
        description: 'Primary and secondary research for product decisions.',
        hourlyRate: 225,
        priceRange: [6000, 12000],
        timeframe: '2–4 weeks',
        deliverables: ['1 research system', '2 revisions'],
        tools: ['Miro', 'UserTesting', 'Figma', 'Google Analytics']
      },
      mobile_app_design: {
        id: 'mobile_app_design',
        title: 'Mobile App UI Design',
        thumbnails: ['iOS + Android screens', 'Gesture systems', 'Dark mode structures'],
        pricing: '$200/hr | $4,000–$10,000',
        tldr: 'Native mobile UI built to Apple HIG & Material design rules.',
        description: 'Native mobile UI built to Apple HIG & Material design rules.',
        hourlyRate: 200,
        priceRange: [4000, 10000],
        timeframe: '2–4 weeks',
        deliverables: ['5–10 screens', '2 revisions'],
        tools: ['Figma', 'Sketch', 'Adobe XD']
      },
      web_app_interface: {
        id: 'web_app_interface',
        title: 'Web Application Interface Design',
        thumbnails: ['SaaS dashboards', 'Admin control panels', 'Data table systems'],
        pricing: '$225/hr | $6,000–$15,000',
        tldr: 'Complex UI for dashboards, SaaS, and data-heavy platforms.',
        description: 'Complex UI for dashboards, SaaS, and data-heavy platforms.',
        hourlyRate: 225,
        priceRange: [6000, 15000],
        timeframe: '2–4 weeks',
        deliverables: ['6–12 screens', '2 revisions'],
        tools: ['Figma', 'Sketch', 'Adobe XD']
      },
      data_visualization: {
        id: 'data_visualization',
        title: 'Real-Time Data Visualization UI',
        thumbnails: ['Live KPI dashboards', 'Streaming data charts', 'Telemetry overlays'],
        pricing: '$225/hr | $8,000–$20,000',
        tldr: 'Dynamic analytics interfaces powered by API data and telemetry.',
        description: 'Dynamic analytics interfaces powered by API data and telemetry.',
        hourlyRate: 225,
        priceRange: [8000, 20000],
        timeframe: '3–6 weeks',
        deliverables: ['Full dashboard', '2 revisions'],
        tools: ['Figma', 'D3.js', 'Chart.js', 'Tableau']
      },
      ai_assisted_design: {
        id: 'ai_assisted_design',
        title: 'AI-Assisted Product Design',
        thumbnails: ['AI layout generation', 'Smart UI adaptation', 'Automated design workflows'],
        pricing: '$250/hr | $8,000–$20,000',
        tldr: 'AI-powered UI generation, optimization, and adaptive design logic.',
        description: 'AI-powered UI generation, optimization, and adaptive design logic.',
        hourlyRate: 250,
        priceRange: [8000, 20000],
        timeframe: '3–5 weeks',
        deliverables: ['Multi-phase system', '2 revisions'],
        tools: ['Figma', 'AI Tools', 'Python', 'TensorFlow']
      },
      ux_education: {
        id: 'ux_education',
        title: 'UX Education, Workshops & Training',
        thumbnails: ['Workshop decks', 'Figma live training', 'Design sprint boards'],
        pricing: '$250/hr | $1,500–$3,500 per session',
        tldr: 'UX, Figma, design systems, and research training for teams.',
        description: 'UX, Figma, design systems, and research training for teams.',
        hourlyRate: 250,
        priceRange: [1500, 3500],
        timeframe: '1–3 days per session',
        deliverables: ['Custom curriculum', '1 revision'],
        tools: ['Figma', 'Miro', 'Google Slides', 'Zoom']
      }
    }
  },
  development: {
    id: 'development',
    title: 'Development & Engineering',
    icon: 'bi-laptop',
    description: 'Front-end development, web applications, and technical implementation',
    color: '#9C27B0',
    services: {
      react_landing: {
        id: 'react_landing',
        title: 'React / Next.js Landing Page Development',
        thumbnails: ['High-conversion hero layout', 'SEO + Lighthouse score board', 'Mobile-first landing UI'],
        pricing: '$185/hr | $4,500–$7,000',
        tldr: 'Fast, SEO-optimized, mobile-responsive landing pages with analytics and form integration.',
        description: 'Fast, SEO-optimized, mobile-responsive landing pages with analytics and form integration.',
        hourlyRate: 185,
        priceRange: [4500, 7000],
        timeframe: '1–2 weeks',
        deliverables: ['1 build', '2 revisions'],
        tools: ['React', 'Next.js', 'Tailwind CSS', 'Vercel']
      },
      multipage_website: {
        id: 'multipage_website',
        title: 'Multi-Page Website Development',
        thumbnails: ['Marketing site layout', 'CMS-ready architecture', 'Accessibility audit overlay'],
        pricing: '$200/hr | $10,000–$18,000',
        tldr: 'Scalable marketing or product websites with routing, CMS, SEO, and accessibility.',
        description: 'Scalable marketing or product websites with routing, CMS, SEO, and accessibility.',
        hourlyRate: 200,
        priceRange: [10000, 18000],
        timeframe: '3–4 weeks',
        deliverables: ['1 site build', '2 revisions'],
        tools: ['React', 'Next.js', 'CMS', 'Vercel']
      },
      full_web_app: {
        id: 'full_web_app',
        title: 'Full Web Application Development',
        thumbnails: ['SaaS dashboard', 'Auth + RBAC flow', 'API-driven UI'],
        pricing: '$250/hr | $18,000–$40,000',
        tldr: 'Production-grade SaaS platforms with full auth, dashboards, and API integrations.',
        description: 'Production-grade SaaS platforms with full auth, dashboards, and API integrations.',
        hourlyRate: 250,
        priceRange: [18000, 40000],
        timeframe: '6–8 weeks',
        deliverables: ['1 application', '2 revisions'],
        tools: ['React', 'Django', 'PostgreSQL', 'AWS']
      },
      mobile_app: {
        id: 'mobile_app',
        title: 'Mobile App Development (React Native)',
        thumbnails: ['iOS + Android screens', 'Push notification flows', 'App Store build pipeline'],
        pricing: '$250/hr | $15,000–$28,000',
        tldr: 'Cross-platform MVP or production-ready mobile applications.',
        description: 'Cross-platform MVP or production-ready mobile applications.',
        hourlyRate: 250,
        priceRange: [15000, 28000],
        timeframe: '4–6 weeks',
        deliverables: ['1 app build', '2 revisions'],
        tools: ['React Native', 'Expo', 'Firebase', 'TestFlight']
      },
      backend_dev: {
        id: 'backend_dev',
        title: 'Back-End Development & APIs',
        thumbnails: ['API endpoint maps', 'Database schema', 'Admin dashboard'],
        pricing: '$225/hr | $8,000–$20,000',
        tldr: 'Secure REST APIs, authentication, and PostgreSQL data architecture.',
        description: 'Secure REST APIs, authentication, and PostgreSQL data architecture.',
        hourlyRate: 225,
        priceRange: [8000, 20000],
        timeframe: '2–4 weeks',
        deliverables: ['1 backend system', '2 revisions'],
        tools: ['Python', 'Django', 'PostgreSQL', 'Redis']
      },
      api_integration: {
        id: 'api_integration',
        title: 'API Design & Integration',
        thumbnails: ['Swagger API docs', 'Axios service layer', 'Data flow diagrams'],
        pricing: '$200/hr | $3,000–$7,500',
        tldr: 'Schema-safe API connections between frontend, backend, and third-party services.',
        description: 'Schema-safe API connections between frontend, backend, and third-party services.',
        hourlyRate: 200,
        priceRange: [3000, 7500],
        timeframe: '1–2 weeks',
        deliverables: ['1 data layer', '2 revisions'],
        tools: ['REST', 'GraphQL', 'Swagger', 'Postman']
      },
      cms_development: {
        id: 'cms_development',
        title: 'CMS & Headless Integration',
        thumbnails: ['Headless CMS diagram', 'Admin UI', 'Content API pipeline'],
        pricing: '$200/hr | $4,000–$9,000',
        tldr: 'WordPress, Django CMS, Strapi, or Sanity integrations with API delivery.',
        description: 'WordPress, Django CMS, Strapi, or Sanity integrations with API delivery.',
        hourlyRate: 200,
        priceRange: [4000, 9000],
        timeframe: '2–3 weeks',
        deliverables: ['1 CMS system', '2 revisions'],
        tools: ['Strapi', 'Sanity', 'WordPress', 'Contentful']
      },
      ecommerce_dev: {
        id: 'ecommerce_dev',
        title: 'E-Commerce Platform Development',
        thumbnails: ['Product grid UI', 'Checkout + Stripe flow', 'Admin order dashboard'],
        pricing: '$225/hr | $10,000–$25,000',
        tldr: 'Shopify, WooCommerce, or custom storefronts with payment + fulfillment systems.',
        description: 'Shopify, WooCommerce, or custom storefronts with payment + fulfillment systems.',
        hourlyRate: 225,
        priceRange: [10000, 25000],
        timeframe: '4–6 weeks',
        deliverables: ['1 store build', '2 revisions'],
        tools: ['Shopify', 'WooCommerce', 'Stripe', 'PayPal']
      },
      data_dashboards: {
        id: 'data_dashboards',
        title: 'Data Visualization Dashboards',
        thumbnails: ['KPI dashboard', 'Live analytics feed', 'Chart mapping layers'],
        pricing: '$250/hr | $10,000–$25,000',
        tldr: 'Real-time KPI dashboards using MD99, D3, or API-driven charting.',
        description: 'Real-time KPI dashboards using MD99, D3, or API-driven charting.',
        hourlyRate: 250,
        priceRange: [10000, 25000],
        timeframe: '4–6 weeks',
        deliverables: ['1 dashboard', '2 revisions'],
        tools: ['React', 'D3.js', 'Chart.js', 'MD99']
      },
      realtime_interfaces: {
        id: 'realtime_interfaces',
        title: 'Real-Time Application Interfaces',
        thumbnails: ['WebSocket chat UI', 'Live event telemetry', 'Realtime graph updates'],
        pricing: '$250/hr | $8,000–$20,000',
        tldr: 'Live chat, streaming dashboards, and real-time data platforms.',
        description: 'Live chat, streaming dashboards, and real-time data platforms.',
        hourlyRate: 250,
        priceRange: [8000, 20000],
        timeframe: '3–5 weeks',
        deliverables: ['1 live system', '2 revisions'],
        tools: ['WebSocket', 'Socket.io', 'React', 'Node.js']
      },
      ai_ml_apps: {
        id: 'ai_ml_apps',
        title: 'AI-Integrated Application Development',
        thumbnails: ['AI UI workflows', 'Prompt-to-output pipelines', 'LLM orchestration maps'],
        pricing: '$275/hr | $12,000–$30,000',
        tldr: 'Web apps powered by OpenAI, Mistral, Gemini, or custom ML APIs.',
        description: 'Web apps powered by OpenAI, Mistral, Gemini, or custom ML APIs.',
        hourlyRate: 275,
        priceRange: [12000, 30000],
        timeframe: '4–8 weeks',
        deliverables: ['1 AI system', '2 revisions'],
        tools: ['OpenAI', 'LangChain', 'Python', 'React']
      },
      automation_systems: {
        id: 'automation_systems',
        title: 'Automation & Workflow Engineering',
        thumbnails: ['Workflow pipelines', 'Trigger/action maps', 'API connector grids'],
        pricing: '$225/hr | $5,000–$15,000',
        tldr: 'Automated pipelines for content, data sync, analytics, and reporting.',
        description: 'Automated pipelines for content, data sync, analytics, and reporting.',
        hourlyRate: 225,
        priceRange: [5000, 15000],
        timeframe: '1–3 weeks',
        deliverables: ['1 automation stack', '2 revisions'],
        tools: ['n8n', 'Zapier', 'Make', 'Python']
      },
      ar_vr_3d: {
        id: 'ar_vr_3d',
        title: 'AR / VR / 3D Product Development',
        thumbnails: ['WebXR scenes', '3D interface mockups', 'Spatial interaction grids'],
        pricing: '$275/hr | $10,000–$30,000',
        tldr: 'Immersive WebXR, Three.js, and spatial interface systems.',
        description: 'Immersive WebXR, Three.js, and spatial interface systems.',
        hourlyRate: 275,
        priceRange: [10000, 30000],
        timeframe: '4–8 weeks',
        deliverables: ['1 immersive system', '2 revisions'],
        tools: ['Three.js', 'WebXR', 'Blender', 'Unity']
      },
      iot_interfaces: {
        id: 'iot_interfaces',
        title: 'IoT Interface Development',
        thumbnails: ['Sensor dashboards', 'Device data flows', 'MQTT pipelines'],
        pricing: '$250/hr | $10,000–$25,000',
        tldr: 'Dashboards and controls for smart devices and sensor networks.',
        description: 'Dashboards and controls for smart devices and sensor networks.',
        hourlyRate: 250,
        priceRange: [10000, 25000],
        timeframe: '4–8 weeks',
        deliverables: ['1 IoT system', '2 revisions'],
        tools: ['MQTT', 'React', 'Node.js', 'Arduino']
      },
      performance_optimization: {
        id: 'performance_optimization',
        title: 'Performance Optimization & Accessibility',
        thumbnails: ['Lighthouse audit scores', 'Bundle size breakdowns', 'WCAG remediation layers'],
        pricing: '$200/hr | $2,500–$6,000',
        tldr: 'Code-level tuning for speed, UX, and WCAG 2.2 compliance.',
        description: 'Code-level tuning for speed, UX, and WCAG 2.2 compliance.',
        hourlyRate: 200,
        priceRange: [2500, 6000],
        timeframe: '1–2 weeks',
        deliverables: ['1 optimization pass', '2 revisions'],
        tools: ['Lighthouse', 'Webpack', 'Chrome DevTools', 'Axe']
      },
      testing_qa: {
        id: 'testing_qa',
        title: 'Testing & QA Automation',
        thumbnails: ['Playwright test flows', 'Cypress dashboards', 'CI test gates'],
        pricing: '$185/hr | $1,800–$4,500',
        tldr: 'Unit, integration, and end-to-end testing pipelines.',
        description: 'Unit, integration, and end-to-end testing pipelines.',
        hourlyRate: 185,
        priceRange: [1800, 4500],
        timeframe: '1–2 weeks',
        deliverables: ['1 test suite', '2 revisions'],
        tools: ['Playwright', 'Cypress', 'Jest', 'Vitest']
      },
      cicd_devops: {
        id: 'cicd_devops',
        title: 'CI/CD & DevOps Infrastructure',
        thumbnails: ['GitHub Actions pipelines', 'Docker build flows', 'Cloud deploy stages'],
        pricing: '$200/hr | $2,000–$4,500',
        tldr: 'Automated deployment pipelines with environment management.',
        description: 'Automated deployment pipelines with environment management.',
        hourlyRate: 200,
        priceRange: [2000, 4500],
        timeframe: '5–10 days',
        deliverables: ['1 pipeline system', '2 revisions'],
        tools: ['GitHub Actions', 'Docker', 'Kubernetes', 'Terraform']
      },
      system_architecture: {
        id: 'system_architecture',
        title: 'System Architecture & Technical Planning',
        thumbnails: ['Infrastructure diagrams', 'Data dependency maps', 'Stack selection boards'],
        pricing: '$250/hr | $5,000–$12,000',
        tldr: 'Full technical blueprinting and architecture documentation.',
        description: 'Full technical blueprinting and architecture documentation.',
        hourlyRate: 250,
        priceRange: [5000, 12000],
        timeframe: '1–2 weeks',
        deliverables: ['1 architecture plan', '2 revisions'],
        tools: ['Lucidchart', 'Miro', 'Notion', 'Draw.io']
      },
      cloud_deployment: {
        id: 'cloud_deployment',
        title: 'Cloud Deployment & Server Configuration',
        thumbnails: ['Vercel/GCP pipelines', 'DNS + SSL setup', 'Prod/staging layouts'],
        pricing: '$200/hr | $2,500–$6,000',
        tldr: 'Production deployment on Vercel, Netlify, Render, or GCP.',
        description: 'Production deployment on Vercel, Netlify, Render, or GCP.',
        hourlyRate: 200,
        priceRange: [2500, 6000],
        timeframe: '5–10 days',
        deliverables: ['1 deployment system', '2 revisions'],
        tools: ['Vercel', 'Netlify', 'GCP', 'AWS']
      }
    }
  },
  consulting: {
    id: 'consulting',
    title: 'Creative Consulting',
    icon: 'bi-lightbulb',
    description: 'Strategic consulting, workshops, and creative direction',
    color: '#FF5722',
    services: {
      strategic_consulting: {
        id: 'strategic_consulting',
        title: 'Strategic Creative Consulting (90-Min Session)',
        thumbnails: ['Live whiteboard strategy session', 'Figma/FigJam collaboration board', 'Executive action memo mockup'],
        pricing: '$300/hr | $1,000 flat',
        tldr: 'High-impact advisory session for brand, UX, product, or business strategy with a post-session strategic memo.',
        description: 'High-impact advisory session for brand, UX, product, or business strategy with a post-session strategic memo.',
        hourlyRate: 300,
        priceRange: [1000, 1000],
        timeframe: '1 day (prep + session + memo)',
        deliverables: ['1 session', '1 memo revision'],
        tools: ['Zoom', 'FigJam', 'Notion']
      },
      creative_direction: {
        id: 'creative_direction',
        title: 'Creative Direction & Brand Leadership',
        thumbnails: ['Visual direction boards', 'Campaign alignment grids', 'Creative feedback deck'],
        pricing: '$250/hr | $7,500–$14,000',
        tldr: 'Hands-on leadership guiding branding, UX, storytelling, and campaign execution.',
        description: 'Hands-on leadership guiding branding, UX, storytelling, and campaign execution.',
        hourlyRate: 250,
        priceRange: [7500, 14000],
        timeframe: '2–6 weeks',
        deliverables: ['Ongoing direction', '2 revision rounds per phase'],
        tools: ['Figma', 'Adobe CC', 'Notion']
      },
      executive_retainer: {
        id: 'executive_retainer',
        title: 'Executive Creative Retainer (Fractional CCO/CDO)',
        thumbnails: ['Executive dashboard', 'Monthly strategy roadmap', 'Cross-team leadership reviews'],
        pricing: '$11,000/month (20 hrs)',
        tldr: 'Part-time executive-level creative and product leadership for startups and agencies.',
        description: 'Part-time executive-level creative and product leadership for startups and agencies.',
        hourlyRate: 550,
        priceRange: [11000, 11000],
        timeframe: 'Monthly (renewable)',
        deliverables: ['Ongoing leadership', 'Continuous iterations'],
        tools: ['Notion', 'Figma', 'Slack']
      },
      brand_strategy_architecture: {
        id: 'brand_strategy_architecture',
        title: 'Brand Strategy & Identity Architecture',
        thumbnails: ['Brand purpose matrix', 'Identity architecture systems', 'Messaging + visual alignment'],
        pricing: '$250/hr | $9,000–$25,000',
        tldr: 'Defines mission, voice, positioning, identity system, and brand activation strategy.',
        description: 'Defines mission, voice, positioning, identity system, and brand activation strategy.',
        hourlyRate: 250,
        priceRange: [9000, 25000],
        timeframe: '3–5 weeks',
        deliverables: ['1 master system', '2 revisions'],
        tools: ['Figma', 'Miro', 'Adobe CC']
      },
      product_experience_strategy: {
        id: 'product_experience_strategy',
        title: 'Product & Experience Strategy',
        thumbnails: ['Experience journey maps', 'Product roadmap Gantt', 'Feature prioritization grids'],
        pricing: '$225/hr | $8,000–$20,000',
        tldr: 'System-level UX strategy, roadmap planning, and product experience design.',
        description: 'System-level UX strategy, roadmap planning, and product experience design.',
        hourlyRate: 225,
        priceRange: [8000, 20000],
        timeframe: '3–5 weeks',
        deliverables: ['1 product strategy', '2 revisions'],
        tools: ['Figma', 'Miro', 'ProductPlan']
      },
      visual_campaign_consulting: {
        id: 'visual_campaign_consulting',
        title: 'Visual Communication & Campaign Consulting',
        thumbnails: ['Campaign storytelling boards', 'Copy + visual integration', 'Launch strategy decks'],
        pricing: '$200/hr | $6,000–$18,000',
        tldr: 'Strategic oversight of storytelling, art direction, and marketing message systems.',
        description: 'Strategic oversight of storytelling, art direction, and marketing message systems.',
        hourlyRate: 200,
        priceRange: [6000, 18000],
        timeframe: '2–5 weeks',
        deliverables: ['2 campaign frameworks', '2 revisions'],
        tools: ['Adobe CC', 'Figma', 'Notion']
      },
      design_systems_ops: {
        id: 'design_systems_ops',
        title: 'Design Systems & Creative Ops Advisory',
        thumbnails: ['Design ops workflows', 'Figma → React pipelines', 'Governance documentation'],
        pricing: '$225/hr | $8,000–$25,000',
        tldr: 'Establishes scalable design systems, tokens, workflows, and governance.',
        description: 'Establishes scalable design systems, tokens, workflows, and governance.',
        hourlyRate: 225,
        priceRange: [8000, 25000],
        timeframe: '3–6 weeks',
        deliverables: ['1 ops system', '2 revisions'],
        tools: ['Figma', 'Storybook', 'GitHub']
      },
      content_presentation_strategy: {
        id: 'content_presentation_strategy',
        title: 'Content & Presentation Design Strategy',
        thumbnails: ['Executive slide decks', 'Data storytelling layouts', 'Presentation hierarchy systems'],
        pricing: '$200/hr | $3,000–$9,000',
        tldr: 'Narrative-driven decks, reports, and communication systems for executives and investors.',
        description: 'Narrative-driven decks, reports, and communication systems for executives and investors.',
        hourlyRate: 200,
        priceRange: [3000, 9000],
        timeframe: '1–3 weeks',
        deliverables: ['1 deck system', '2 revisions'],
        tools: ['Figma', 'PowerPoint', 'Keynote']
      },
      ux_research_behavioral: {
        id: 'ux_research_behavioral',
        title: 'UX Research & Behavioral Insight Consulting',
        thumbnails: ['Behavioral models', 'Persona/sentiment analysis', 'Usability insight boards'],
        pricing: '$225/hr | $5,000–$15,000',
        tldr: 'Guided research strategy for human-centered, data-driven product decisions.',
        description: 'Guided research strategy for human-centered, data-driven product decisions.',
        hourlyRate: 225,
        priceRange: [5000, 15000],
        timeframe: '2–4 weeks',
        deliverables: ['1 research program', '2 revisions'],
        tools: ['Miro', 'UserTesting', 'Notion']
      },
      ai_automation_strategy: {
        id: 'ai_automation_strategy',
        title: 'AI & Automation Creative Strategy',
        thumbnails: ['AI workflow pipelines', 'Prompt-to-creative systems', 'Automation orchestration maps'],
        pricing: '$275/hr | $10,000–$25,000',
        tldr: 'Strategic integration of AI tools and creative automation into business workflows.',
        description: 'Strategic integration of AI tools and creative automation into business workflows.',
        hourlyRate: 275,
        priceRange: [10000, 25000],
        timeframe: '3–6 weeks',
        deliverables: ['1 automation strategy', '2 revisions'],
        tools: ['OpenAI', 'Zapier', 'Figma']
      },
      experiential_branding: {
        id: 'experiential_branding',
        title: 'Environmental & Experiential Branding Consulting',
        thumbnails: ['Event experience concepts', 'Exhibition + signage systems', 'Spatial interaction mockups'],
        pricing: '$250/hr | $10,000–$35,000',
        tldr: 'Brings brands into physical, spatial, and experiential environments.',
        description: 'Brings brands into physical, spatial, and experiential environments.',
        hourlyRate: 250,
        priceRange: [10000, 35000],
        timeframe: '4–8 weeks',
        deliverables: ['2 environment concepts', '2 revisions'],
        tools: ['Cinema 4D', 'Adobe CC', 'Figma']
      },
      cross_media_leadership: {
        id: 'cross_media_leadership',
        title: 'Cross-Media Creative Leadership',
        thumbnails: ['Print + web + motion system boards', 'Vendor coordination workflows', 'Multi-channel rollout maps'],
        pricing: '$225/hr | $8,000–$20,000',
        tldr: 'Ensures brand consistency across web, print, motion, and interactive platforms.',
        description: 'Ensures brand consistency across web, print, motion, and interactive platforms.',
        hourlyRate: 225,
        priceRange: [8000, 20000],
        timeframe: '3–6 weeks',
        deliverables: ['1 cross-media system', '2 revisions'],
        tools: ['Adobe CC', 'Figma', 'After Effects']
      },
      communication_copywriting: {
        id: 'communication_copywriting',
        title: 'Strategic Communication & Copywriting Advisory',
        thumbnails: ['Voice & tone matrices', 'UX copy frameworks', 'Scripted narrative arcs'],
        pricing: '$185/hr | $2,500–$6,000',
        tldr: 'Shapes brand tone, narrative structure, and executive communication frameworks.',
        description: 'Shapes brand tone, narrative structure, and executive communication frameworks.',
        hourlyRate: 185,
        priceRange: [2500, 6000],
        timeframe: '1–3 weeks',
        deliverables: ['1 narrative system', '2 revisions'],
        tools: ['Notion', 'Google Docs', 'Figma']
      },
      business_marketing_strategy: {
        id: 'business_marketing_strategy',
        title: 'Business, Marketing & Operations Strategy',
        thumbnails: ['Market analysis frameworks', 'Business model canvases', 'KPI mapping systems'],
        pricing: '$250/hr | $8,000–$20,000',
        tldr: 'Aligns creative strategy with business growth, marketing execution, and operations.',
        description: 'Aligns creative strategy with business growth, marketing execution, and operations.',
        hourlyRate: 250,
        priceRange: [8000, 20000],
        timeframe: '3–6 weeks',
        deliverables: ['1 business strategy', '2 revisions'],
        tools: ['Miro', 'Notion', 'Excel']
      },
      educational_workshops: {
        id: 'educational_workshops',
        title: 'Educational, Mentorship & Workshop Programs',
        thumbnails: ['Live teaching sessions', 'Workshop curriculum decks', 'Team training systems'],
        pricing: '$200/hr | $3,000–$10,000',
        tldr: '1:1 or team-based instruction in UX, design systems, storytelling, and creative leadership.',
        description: '1:1 or team-based instruction in UX, design systems, storytelling, and creative leadership.',
        hourlyRate: 200,
        priceRange: [3000, 10000],
        timeframe: '1–6 weeks depending on program',
        deliverables: ['Custom program', '1 revision'],
        tools: ['Zoom', 'Figma', 'Notion']
      }
    }
  },
  packages: {
    id: 'packages',
    title: 'Discounted Packages',
    icon: 'bi-box-seam',
    description: 'Bundled services with significant cost savings',
    color: '#4CAF50',
    services: {
      brand_starter: {
        id: 'brand_starter',
        title: 'Brand Starter Package',
        thumbnails: ['Logo + color + type overview', 'Mini brand guide spread', 'Social profile mockup set'],
        pricing: '$5,500 flat (discounted)',
        tldr: 'Perfect for new businesses. Includes logo design, color palette, typography system, and a lightweight brand guide with social-ready assets.',
        description: 'Perfect for new businesses. Includes logo design, color palette, typography system, and a lightweight brand guide with social-ready assets.',
        priceRange: [5500, 5500],
        timeframe: '10–14 days',
        deliverables: ['3 logo concepts', '2 revision rounds'],
        tools: ['Adobe CC', 'Figma']
      },
      digital_presence_launch: {
        id: 'digital_presence_launch',
        title: 'Digital Presence Launch Package',
        thumbnails: ['Homepage + mobile mockups', 'SEO + performance panel', 'CMS-ready layout'],
        pricing: '$9,800 flat (discounted)',
        tldr: 'Complete brand + marketing website launch with responsive UI, SEO setup, and analytics.',
        description: 'Complete brand + marketing website launch with responsive UI, SEO setup, and analytics.',
        priceRange: [9800, 9800],
        timeframe: '3–4 weeks',
        deliverables: ['1 site concept', '2 revisions'],
        tools: ['React', 'Figma', 'CMS']
      },
      product_mvp_design: {
        id: 'product_mvp_design',
        title: 'Product MVP Design Package',
        thumbnails: ['UX flow diagrams', 'Wireframes → UI screens', 'Interactive prototype preview'],
        pricing: '$13,500 flat (discounted)',
        tldr: 'Full UX strategy, wireframes, high-fidelity UI, and clickable prototype for startup MVPs.',
        description: 'Full UX strategy, wireframes, high-fidelity UI, and clickable prototype for startup MVPs.',
        priceRange: [13500, 13500],
        timeframe: '3–5 weeks',
        deliverables: ['10–15 screens', '2 revisions'],
        tools: ['Figma', 'Prototyping', 'UX Tools']
      },
      design_build_startup: {
        id: 'design_build_startup',
        title: 'Design + Build Startup Bundle',
        thumbnails: ['Product UI + API architecture', 'Marketing site + dashboard', 'Deployment pipeline overview'],
        pricing: '$17,500 flat (discounted)',
        tldr: 'End-to-end startup launch: branding, UX/UI, website or web app MVP, and cloud deployment.',
        description: 'End-to-end startup launch: branding, UX/UI, website or web app MVP, and cloud deployment.',
        priceRange: [17500, 17500],
        timeframe: '6–8 weeks',
        deliverables: ['Full product system', '2 revisions'],
        tools: ['React', 'Figma', 'Cloud Platforms']
      },
      automation_jumpstart: {
        id: 'automation_jumpstart',
        title: 'Automation Jumpstart Package',
        thumbnails: ['n8n workflow maps', 'API automation pipelines', 'Dashboard automation results'],
        pricing: '$4,000 flat (discounted)',
        tldr: 'Rapid automation setup for content, analytics, CRM, or internal operations using n8n or API workflows.',
        description: 'Rapid automation setup for content, analytics, CRM, or internal operations using n8n or API workflows.',
        priceRange: [4000, 4000],
        timeframe: '1–2 weeks',
        deliverables: ['1 automation system', '2 revisions'],
        tools: ['n8n', 'API Tools', 'Workflow Automation']
      },
      pitch_ready_founder: {
        id: 'pitch_ready_founder',
        title: 'Pitch-Ready Founder Package',
        thumbnails: ['Investor deck layouts', 'Brand story arc', 'Data visualization slides'],
        pricing: '$8,800 flat (discounted)',
        tldr: 'Investor-grade pitch deck, product narrative, branding alignment, and data storytelling.',
        description: 'Investor-grade pitch deck, product narrative, branding alignment, and data storytelling.',
        priceRange: [8800, 8800],
        timeframe: '2–3 weeks',
        deliverables: ['1 deck system', '2 revisions'],
        tools: ['Figma', 'PowerPoint', 'Data Visualization']
      },
      executive_retainer_package: {
        id: 'executive_retainer_package',
        title: 'Executive Consulting Retainer (Package)',
        thumbnails: ['Monthly strategy dashboard', 'Cross-team leadership boards', 'KPI + roadmap overlays'],
        pricing: '$11,500/month (discounted)',
        tldr: 'Fractional executive leadership across UX, brand, product, automation, and strategy.',
        description: 'Fractional executive leadership across UX, brand, product, automation, and strategy.',
        priceRange: [11500, 11500],
        timeframe: 'Monthly (renewable)',
        deliverables: ['Ongoing strategic leadership', 'continuous revisions'],
        tools: ['Notion', 'Figma', 'Strategic Tools']
      }
    }
  }
};

// Legacy services array for backward compatibility
export const SERVICES = Object.values(SERVICE_CATEGORIES).flatMap(category =>
  Object.values(category.services).map(service => ({
    id: service.id,
    title: service.title,
    tldr: service.tldr,
    long: service.description,
    price: service.priceRange ? service.priceRange[0] : service.hourlyRate * 8, // Fallback price
    category: category.id,
    categoryTitle: category.title
  }))
);

// Calendly Configuration
export const CALENDLY_CONFIG = {
  kickoffMeeting: 'https://calendly.com/johncrawforddesign/kickoff-meeting',
  username: 'johncrawforddesign'
};
